import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13106a68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "album" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "line1" }

import gospel, { State } from '@/store/gospel/category';
import home, { State as HomeState } from '@/store/gospel/home';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const cid = computed(() => parseInt(route.params.id as string))
const store = useStore()
const homeState = computed<HomeState>(() => store.state[home.name])
const gospelState = computed<State>(() => store.state[gospel.name])
const categoriesData = computed(() => gospelState.value.list)

const title = computed(() => homeState.value.menu.find(item => item.id == cid.value))

function onGoBook(id: number) {
    router.push({
        name: 'gospel/view',
        params: { id }
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(title))
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(title).name), 1))
        : _createCommentVNode("", true),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoriesData), (item) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createElementVNode("a", {
              onClick: ($event: any) => (onGoBook(item.id))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: item.thumb
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1)
            ], 8, _hoisted_4)
          ]))
        }), 256))
      ])
    ])
  ]))
}
}

})